import React from 'react';

import { useParams } from 'react-router-dom';

import WarranteeEditInfoCard from './WarranteeInfoEditCard';
import WarranteeEditingActionCard from './WarranteeEditingActionCard';
import Card from '@mui/material/Card';
import UnauthorisedAccess from '../CommonComponents/UnauthorisedAccess';

export default function WarranteeEditCard(props) {
  let warranteeCardTitle = props.title;
  let rowData = props.rowData;
  const [useType, setUseType] = React.useState(localStorage.getItem('type'));
  return  useType === 'technician' ? (
    <UnauthorisedAccess />
  ) : (
    <Card
      sx={{
        background: 'pink',
        border: 'none',
        boxShadow: 'none',
        padding: '10px',
      }}
    >
      <WarranteeEditInfoCard rowData={rowData} titleInfo={warranteeCardTitle} />
      <WarranteeEditingActionCard />
    </Card>
  );
}
